var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('p',{staticClass:"text-body-2 text--secondary mb-4"},[_vm._v(_vm._s(_vm.$t('onboarding.pending-orders.explained')))]),_c('order-queue',{attrs:{"organization-id":_vm.organizationId,"embedded":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }